var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    fill: "#F6F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    d: "M16 16h24v24H16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.154 22.75a4.75 4.75 0 1 0 9.5 0 4.75 4.75 0 0 0-9.5 0v0ZM19 38c0-2.298.948-4.503 2.636-6.128 1.688-1.626 3.977-2.539 6.364-2.539s4.676.913 6.364 2.539C36.052 33.497 37 35.702 37 38",
    stroke: "#272E34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgDefaultAvatar as ReactComponent };
export default __webpack_public_path__ + "742cf363061a0d2aa0e8b9955a6cd88b.svg";